import MedicalHistory from "./medicalHistory"

export { config } from "./_config"
export default MedicalHistory
